import styled from 'styled-components';

export const StyledContactForm = styled.div`
    width: 60%;
    margin: auto;
    form {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        width: 100%;
        font-size: 16px;
        input {
        width: 100%;
        height: 35px;
        padding: 7px;
        margin-bottom: 10px;
        outline: none;
        border-radius: 5px;
        border: 1px solid rgb(220, 220, 220);
        &:focus {
            border: 2px solid rgba(0, 206, 158, 1);
        }
        }
        textarea {
        max-width: 100%;
        min-width: 100%;
        width: 100%;
        max-height: 100px;
        min-height: 100px;
        padding: 7px;
        outline: none;
        border-radius: 5px;
        border: 1px solid rgb(220, 220, 220);
        &:focus {
            border: 2px solid rgba(0, 206, 158, 1);
        }
        }
        label {
        margin-top: 1rem;
        }
        input[type="submit"] {
        margin-top: 2rem;
        cursor: pointer;
        background: rgb(0, 11, 91);
        color: white;
        border: none;
        }
    }`;


export const FeatureTitle = styled.h2`
	text-align: center;
	font-size: clamp(0.7rem, 5vw, 1.5rem);
	line-height: 1.06;
	letter-spacing: 0.4rem;
	margin: auto;
`;

export const FeatureTextWrapper = styled.div`
	position: relative;
	padding: 0 0 20px;
	margin-bottom: 0.5rem;
    margin-top: 3rem;
`;
